import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import { Icon } from 'components/Icon';

const InfoCardBlock = ({ title, text }) => {
  if (!title || !text) {
    return <></>;
  }

  const newText = text.length > 30 ? `${text.slice(0, 30)}...` : text;

  return (
    <div className="infocard-line" title={text}>
      {title}: <b>{newText}</b>
    </div>
  );
};

InfoCardBlock.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
};

const InfoCardComment = ({ text }) => {
  if (!text) {
    return <></>;
  }

  const newText = text.length > 20 ? `${text.slice(0, 20)}...` : text;

  return (
    <div className="infocard-line text-comment" title={text}>
      <Icon name="comment" />
      {newText}
    </div>
  );
};

InfoCardComment.propTypes = {
  text: PropTypes.string.isRequired,
};

const InfoCardLink = ({ title, link }) => {
  const history = useHistory();

  const handleClick = (e) => {
    e.preventDefault();
    history.push(link.url, link.params);
  };

  return (
    <a className="infocard-link" onClick={handleClick} href={link}>
      {title}
    </a>
  );
};

InfoCardLink.propTypes = {
  title: PropTypes.string.isRequired,
  link: PropTypes.object.isRequired,
};

export { InfoCardBlock, InfoCardLink, InfoCardComment };
